<template>
  <v-stepper-header>
    <template v-for="(item, index) in steps">
      <v-stepper-step
        :key="item.name"
        :step="index + 1"
        @click="onClickStep(index)"
        :class="{ 'movable-step': isMovable }"
      >
        {{ item.title }}
      </v-stepper-step>
      <v-divider v-if="steps.length > index + 1" :key="`${item.name}Divider`" />
    </template>
  </v-stepper-header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SimulationModelContentNavigation',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('simulation', ['currentStep', 'steps']),
    isMovable() {
      return this.form.basicSetting.isPageMovable
    },
  },
  methods: {
    ...mapActions('simulation', {
      setStep: 'SET_STEP',
    }),
    onClickStep(index) {
      if (!this.isMovable) {
        return
      }
      const targetStep = index + 1
      this.setStep(targetStep)
    },
  },
}
</script>

<style lang="scss" scoped>
.movable-step {
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
}
</style>
